// extracted by mini-css-extract-plugin
export var button = "_eb-4";
export var hasDarkBackground = "_eb-7";
export var hasLightBackground = "_eb-6";
export var iconWrapper = "_eb-0";
export var large = "_eb-2";
export var medium = "_eb-1";
export var small = "_eb-5";
export var xsmall = "_eb-3";